import Vue from "vue";
import VueRouter from "vue-router";
import store from "@/store";

Vue.use(VueRouter);

// Layout
import UnAuthLayout from "../views/layouts/unauth-layout.vue";
import AuthLayout from "../views/layouts/auth-layout.vue";

// Static
import HomePage from "../views/home";


// Auth
import LoginPage from "../views/auth/login.vue";
import ForgotPasswordPage from "../views/auth/forgot-password.vue";

// Companies
import CompaniesPage from "../views/companies/index.vue";
import CompanyCreatePage from "../views/companies/create.vue";
import CompanyIdPage from "../views/companies/id.vue";

// Users
import UsersPage from "../views/users/index.vue";
import UserCreatePage from "../views/users/create.vue";
import UserIdPage from "../views/users/id.vue";
import ProfilePage from "../views/users/id.vue";
import UsersUploadPage from "../views/users/upload.vue";

// Positions
import PositionsPage from "../views/positions/index.vue";
import PositionCreatePage from "../views/positions/create.vue";
import PositionIdPage from "../views/positions/id.vue";

// Roles
import RolesPage from "../views/roles/index.vue";
import RoleIdPage from "../views/roles/id.vue";

// Modules
import ModulesPage from "../views/modules/index.vue";
import ModuleCreatePage from "../views/modules/create.vue";
import ModuleIdPage from "../views/modules/id.vue";

// Permissions
import PermissionsPage from "../views/permissions/index.vue";
import PermissionCreatePage from "../views/permissions/create.vue";
import PermissionIdPage from "../views/permissions/id.vue";

// Values
import Values from "@/views/values/index.vue";
import ValueCreate from "@/views/values/create.vue";
import ValueId from "@/views/values/id.vue";

// ValueLists
import ValueLists from "@/views/value-lists/index.vue";
import ValueListUpload from "@/views/value-lists/upload.vue";
import ValueListCreate from "@/views/value-lists/create.vue";
import ValueListId from "@/views/value-lists/id.vue";

// Hospitals
import HospitalsPage from "../views/hospitals/index.vue";
import HospitalCreatePage from "../views/hospitals/create.vue";
import HospitalIdPage from "../views/hospitals/id.vue";

// Devices
import DevicesPage from "../views/devices/index.vue";
import DeviceCreatePage from "../views/devices/create.vue";
import DeviceIdPage from "../views/devices/id.vue";

// Procedures
import ProceduresPage from "../views/procedures/index.vue";
import ProcedureCreatePage from "../views/procedures/create.vue";
import ProcedureIdPage from "../views/procedures/id.vue";

// Therapy Sessions
import TherapySessionsPage from "../views/therapy_sessions/index.vue";
import TherapySessionCreatePage from "../views/therapy_sessions/create.vue";
import TherapySessionIdPage from "../views/therapy_sessions/id.vue";

// Session Logs
import SessionLogsPage from "../views/session_logs/index.vue";

// Control Logs
import ControlLogsPage from "../views/control_logs/index.vue";
import ControlLogCreatePage from "../views/control_logs/create.vue";
import ControlLogIdPage from "../views/control_logs/id.vue";

// Maintenance Logs
import MaintenanceLogsPage from "../views/maintenance_logs/index.vue";
import MaintenanceLogCreatePage from "../views/maintenance_logs/create.vue";
import MaintenanceLogIdPage from "../views/maintenance_logs/id.vue";



const routes = [
  // Root redirect
  {
    path: "/",
    redirect: "/home"
  },
  // AuthLayout
  {
    path: "/auth",
    name: "AuthLayout",
    component: AuthLayout,
    children: [
      {
        path: "/home",
        name: "HomePage",
        component: HomePage,
      },
      // Comapnies
      {
        path: "/companies",
        name: "CompaniesPage",
        component: CompaniesPage,
      },
      {
        path: "/companies/create",
        name: "CompanyCreatePage",
        component: CompanyCreatePage,
      },
      {
        path: "/companies/:companyId",
        name: "CompanyIdPage",
        component: CompanyIdPage,
      },
      // Users
      {
        path: "/users",
        name: "UsersPage",
        component: UsersPage,
      },
      {
        path: "/users/create",
        name: "UserCreatePage",
        component: UserCreatePage,
      },
      {
        path: "/users/upload",
        name: "UsersUploadPage",
        component: UsersUploadPage,
      },
      {
        path: "/profile/:userId",
        name: "ProfilePage",
        component: ProfilePage,
      },
      {
        path: "/users/:userId",
        name: "UserIdPage",
        component: UserIdPage,
      },
      // Positions
      {
        path: "/positions",
        name: "PositionsPage",
        component: PositionsPage,
      },
      {
        path: "/positions/create",
        name: "PositionCreatePage",
        component: PositionCreatePage,
      },
      {
        path: "/positions/:positionId",
        name: "PositionIdPage",
        component: PositionIdPage,
      },
      // Roles
      {
        path: "/roles",
        name: "RolesPage",
        component: RolesPage,
      },
      {
        path: "/roles/:roleId",
        name: "RoleIdPage",
        component: RoleIdPage,
      },
      // Modules
      {
        path: "/modules",
        name: "ModulesPage",
        component: ModulesPage,
      },
      {
        path: "/modules/create",
        name: "ModuleCreatePage",
        component: ModuleCreatePage,
      },
      {
        path: "/modules/:moduleId",
        name: "ModuleIdPage",
        component: ModuleIdPage,
      },
      // Permissions
      {
        path: "/permissions",
        name: "PermissionsPage",
        component: PermissionsPage,
      },
      {
        path: "/permissions/create",
        name: "PermissionCreatePage",
        component: PermissionCreatePage,
      },
      {
        path: "/permissions/:permissionId",
        name: "PermissionIdPage",
        component: PermissionIdPage,
      },
      // Values
      {
        path: "/values",
        name: "Values",
        component: Values,
      },
      {
        path: "/values/create",
        name: "ValueCreate",
        component: ValueCreate,
      },
      {
        path: "/values/:valueId",
        name: "ValueId",
        component: ValueId,
      },
      // ValueLists
      {
        path: "/value-lists",
        name: "ValueLists",
        component: ValueLists,
      },
      {
        path: "/value-lists/upload",
        name: "ValueListUpload",
        component: ValueListUpload,
      },
      {
        path: "/value-lists/create",
        name: "ValueListCreate",
        component: ValueListCreate,
      },
      {
        path: "/value-lists/:valueListId",
        name: "ValueListId",
        component: ValueListId,
      },
      // Hospitals
      {
        path: "/hospitals",
        name: "HospitalsPage",
        component: HospitalsPage,
      },
      {
        path: "/hospitals/create",
        name: "HospitalCreatePage",
        component: HospitalCreatePage,
      },
      {
        path: "/hospitals/:hospitalId",
        name: "HospitalIdPage",
        component: HospitalIdPage,
      },
      // Devices
      {
        path: "/devices",
        name: "DevicesPage",
        component: DevicesPage,
      },
      {
        path: "/devices/create",
        name: "DeviceCreatePage",
        component: DeviceCreatePage,
      },
      {
        path: "/devices/:deviceId",
        name: "DeviceIdPage",
        component: DeviceIdPage,
      },
      // Procedures
      {
        path: "/procedures",
        name: "ProceduresPage",
        component: ProceduresPage,
      },
      {
        path: "/procedures/create",
        name: "ProcedureCreatePage",
        component: ProcedureCreatePage,
      },
      {
        path: "/procedures/:id",
        name: "ProcedureIdPage",
        component: ProcedureIdPage,
      },
      // Therapy Sessions
      {
        path: "/therapy_sessions",
        name: "TherapySessionsPage",
        component: TherapySessionsPage,
      },
      {
        path: "/therapy_sessions/create",
        name: "TherapySessionCreatePage",
        component: TherapySessionCreatePage,
      },
      {
        path: "/therapy_sessions/:sessionId",
        name: "TherapySessionIdPage",
        component: TherapySessionIdPage,
      },
      
      // Session Logs
      {
        path: "/therapy-sessions/:sessionId/session-logs",
        name: "SessionLogsPage",
        component: SessionLogsPage,
      },
      
      // Control Logs
      {
        path: "/session-logs/:sessionId/control-logs",
        name: "ControlLogsPage",
        component: ControlLogsPage,
      },
      {
        path: "/control_logs/create",
        name: "ControlLogCreatePage",
        component: ControlLogCreatePage,
      },
      {
        path: "/control_logs/:controlLogId",
        name: "ControlLogIdPage",
        component: ControlLogIdPage,
      },
      
      // Maintenance Logs
      {
        path: "/maintenance_logs",
        name: "MaintenanceLogsPage",
        component: MaintenanceLogsPage,
      },
      {
        path: "/maintenance_logs/create",
        name: "MaintenanceLogCreatePage",
        component: MaintenanceLogCreatePage,
      },
      {
        path: "/maintenance_logs/:maintenanceLogId",
        name: "MaintenanceLogIdPage",
        component: MaintenanceLogIdPage,
      },
    ],
  },
  // End AuthLayout

  // UnAuthLayout
  {
    path: "/unauth",
    name: "UnAuthLayout",
    component: UnAuthLayout,
    children: [
      {
        path: "/login",
        name: "LoginPage",
        component: LoginPage,
      },
      {
        path: "/forgot-password",
        name: "ForgotPasswordPage",
        component: ForgotPasswordPage,
      },
    ],
  },
  //End UnAuthLayout
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  console.log("=== Navigation Guard Debug ===");
  console.log("From:", from.name, from.path);
  console.log("To:", to.name, to.path);
  console.log("Authenticated:", store.getters["auth/authenticated"]);
  console.log("User:", store.getters["auth/user"]?.email);
  console.log("Company:", store.getters["auth/company"]?.id);
  
  if (
    to.name === "LoginPage" ||
    to.name === "RegisterPage" ||
    to.name === "ForgotPasswordPage"
  ) {
    console.log("Branch 1: Auth page accessed");
    if (store.getters["auth/authenticated"]) {
      console.log("Branch 1a: Already authenticated, redirecting to home");
      return next({
        name: "HomePage",
      });
    }
    console.log("Branch 1b: Not authenticated, allowing access to auth page");
    next();
  } else if (!store.getters["auth/authenticated"]) {
    console.log("Branch 2: Not authenticated, redirecting to login");
    return next({
      name: "LoginPage",
    });
  } else if (to.name === null) {
    console.log("Branch 3: Route name is null, redirecting to home");
    return next({
      name: "HomePage",
    });
  } else {
    console.log("Branch 4: Allowing navigation");
    next();
  }
});


export default router;
